export function buildFormDataFromItem(item) {
  const formData = new FormData();

  Object.entries(item.payload || {}).forEach(([key, value]) => {
    if (key === 'imageFile' && value) {
      formData.append('image', value, value.name || 'image');
      return;
    }

    if (value === null || value === undefined) {
      return;
    }

    if (typeof value === 'object' && !(value instanceof Blob)) {
      formData.append(key, JSON.stringify(value));
      return;
    }

    formData.append(key, value);
  });

  // Always send a stable id so server inserts are idempotent.
  formData.set('id', item.id);

  return formData;
}

export function getUploadEndpoint(type) {
  if (type === 'story') return '/api/adaptation-stories';
  if (type === 'plan') return '/api/adaptation-plans';
  throw new Error(`Unsupported offline upload type: ${String(type)}`);
}

export async function uploadItem({ apiUrl, item }) {
  const formData = buildFormDataFromItem(item);
  const endpoint = getUploadEndpoint(item.type);

  const res = await fetch(`${apiUrl}${endpoint}`, {
    method: 'POST',
    body: formData,
  });

  if (!res.ok) {
    const errorText = await res.text().catch(() => 'Unknown error');
    throw new Error(`HTTP ${res.status}: ${errorText}`);
  }
}

export function computeBackoffMs(attempts, { baseDelayMs, maxDelayMs }) {
  const exp = Math.max(0, attempts - 1);
  const raw = baseDelayMs * (2 ** exp);
  const capped = Math.min(maxDelayMs, raw);
  const jitter = Math.floor(Math.random() * 1000);
  return capped + jitter;
}
